import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlockuiComponent } from './blockui.component';
import { SpinnerModule } from '../../spinner/spinner.module';


@NgModule({
  declarations: [BlockuiComponent],
  imports: [
    CommonModule,
    SpinnerModule,
  ],
  exports: [BlockuiComponent]
})
export class BlockuiModule {
}
